import * as React from 'react';

interface ConditionProps {
    test: () => boolean;
}

export default class Condition extends React.Component<React.PropsWithChildren<ConditionProps>> {
    render() {
        const { test, children } = this.props;

        if (test())
            return children;

        return null;
    }
}
